import AppConstants from 'constants/AppConstants';
import protos from 'utils/protos';

const { TicketTypeGetRequest } = protos;

/**
 * Fetch all unarchived, current/upcoming experiences for the active business
 */
export function fetchAll(): ApiAction {
  return {
    TockApi: {
      postListProto: '/ticket/type/list',
      request: TicketTypeGetRequest.fromObject({ isArchived: false, future: true }),
      type: AppConstants.ACTIVE_TICKETS_FETCH_ALL,
    },
  };
}
